import React, {useEffect} from 'react';
import {Link, useHistory, useParams} from 'react-router-dom';
import {Button, Card, Descriptions, Divider, Typography} from "antd";
import PropTypes from 'prop-types';

import './applicationDetailTemplate.scss';
import {replaceUrlByParams} from "../../utils/api";
import {PAGE, TIME_FORMAT} from "../../utils/constants";

import moment from 'moment';

ApplicationDetailTemplate.propTypes = {
    sections : PropTypes.array
}

function ApplicationDetailTemplate(props) {
    let sections = {}
    let history = useHistory()
    let {pid, id} = useParams()
    const portal = id ? 'admin' : 'user'

    const {Text} = Typography
    if(props.sections) {
        sections = props.sections
        if(!id){
            id = props.id
        }
    }else{
        history.push(`${replaceUrlByParams(PAGE.LANDING, {':pid':pid})}`)
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function sectionSwitch(section) {
        switch(section.type) {
            case 'profile':
                return (

                    <div className='flex-table col2'>
                        {
                            section.application.map((field, i) => {
                                return (
                                    <div className='cell vertical'  key={i}>
                                        <div className='label'>{field.name}</div>
                                        <div className='value'>{field.value}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            case 'optionalMultipleChoice':
                return (
                    <>
                        {
                            section.application.map((subsection, i) => {
                                return (
                                    <Descriptions
                                        key={i}
                                        column={1}
                                        title={subsection.name}
                                    >
                                        {
                                            subsection.choices.map((field, j) => {
                                                return <Descriptions.Item key={j} label={field.name}>{field.value}</Descriptions.Item>
                                            })
                                        }

                                    </Descriptions>
                                )
                            })
                        }

                        {section.result && (
                            <>
                                <Divider>{`${section.result.title} (最後更新時間:`} <Text code>{moment(section.result.lastUpdate).format(TIME_FORMAT)}</Text>)</Divider>
                                <Descriptions
                                    column={1}
                                >
                                    {
                                        section.result.data.map((field, k) => {
                                            return <Descriptions.Item key={k} label={field.name}>{field.value}</Descriptions.Item>
                                        })
                                    }
                                </Descriptions>
                            </>
                        )}
                    </>
                );

            case 'mandatorySingleChoice':
                const hasAttach = section.result && section.result.attachment
                return (
                    <>
                        <Descriptions
                            column={1}
                        >

                            {section.application.map((apl, i) => {
                               return (
                                   <Descriptions.Item
                                       key={i}
                                        label={apl.name}
                                    >
                                        {apl.value}
                                    </Descriptions.Item>
                               )
                            })

                            }
                           {/*<Descriptions.Item*/}
                           {/*     label={section.application.name}*/}
                           {/* >*/}
                           {/*     {section.application.value}*/}
                           {/* </Descriptions.Item>*/}

                        </Descriptions>

                        {section.result && (
                            <>
                                <Divider>{`${section.result.title} (最後更新時間:`} <Text code>{moment(section.result.lastUpdate).format(TIME_FORMAT)}</Text>)</Divider>
                                <Descriptions
                                    column={1}
                                >
                                    {
                                        section.result.data.map((field, k) => {
                                            return <Descriptions.Item key={k} label={field.label}>{field.value}</Descriptions.Item>
                                        })
                                    }
                                </Descriptions>
                                {hasAttach &&
                                    section.result.attachment.map((file, i) => {
                                        return (
                                            <Button className='test-result' key={i}>
                                                <a download href={file.url}>{file.filename}</a>
                                            </Button>
                                        )
                                    })
                                }

                            </>
                        )}
                    </>
                )

            default: return <></>
        }
    }

    return (
        <div className='application-detail-template'>
            <div className='section-container'>
                <>
                    {
                        sections.map((section, i) => {
                            const hasCert = section.result && section.result.certificate
                            let htmlDescription
                            if(section.description){htmlDescription = { __html: section.description}}
                            return (
                                <Card key={i} title={
                                    <>
                                        {section.title}
                                        {section.description && <Text className='description'><span className='text-area-description' dangerouslySetInnerHTML={htmlDescription}/></Text>}
                                    </>
                                }
                                      extra={ (section.type === 'mandatorySingleChoice') ?
                                            hasCert && (<Button>
                                              <Link to={`${replaceUrlByParams(PAGE.CERTIFICATE, {':portal':portal, ':pid':pid, ':id':id})}`}
                                                    target='_blank'
                                              >
                                                  {section.result.certificate.title}
                                              </Link>
                                          </Button>)
                                          : null
                                }>
                                    <Card.Meta>anc</Card.Meta>
                                    { sectionSwitch(section, i)}
                                </Card>
                            )

                        })
                    }
                </>
            </div>
        </div>
    )
}

export default ApplicationDetailTemplate;
